import { SS, Storage } from 'ls-ts';

export interface TempPromoStore {
  startDate?: string;
  customOrderParameters?: { [key: string]: string };
  customSubscriptionParameters?: { [key: string]: string };
}

/**
 * Temporary promo store is a temporary solution for pesisting some additional data
 * that needs to be passed to the purchase step. It uses Session Storage. Normally Payment Context
 * would be used to store this data, but it felt it would clutter the context too much.
 * Good thing about it is that this way we can quite dynamically adjust the data here without worrying about unexpected impact on other parts of the payment process.
 */
const storage = new Storage<TempPromoStore>('promo_NonSubscribedRedeem', SS);

export default storage;
